import * as React from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "../../../components/mui";
import Modal from "../../../components/shared/Modal";
import { useToast } from "../../../components/shared/ToastProvider";

import "../../../styles/main.css";
import "../../../styles/pages/condoUnitDetail.css";

export default function GenerateMonthlyAllowanceModal({ open, onClose }) {
  const { showToast } = useToast();

  const handleGenerate = () => {
    if (showToast) {
      showToast({ message: "Monthly allowances generated", severity: "success" });
    }
    if (onClose) onClose();
  };

  const actions = (
    <>
      <Button variant="outlined" onClick={onClose}>
        Cancel
      </Button>
      <Button variant="contained" onClick={handleGenerate}>
        Generate
      </Button>
    </>
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Generate Monthly Allowance"
      actions={actions}
      maxWidth="xs"
      fullWidth
    >
      <Box className="modal-form-grid modal-form-grid--spaced">
        <FormControl fullWidth required size="small" className="modal-form-row">
          <InputLabel>Month</InputLabel>
          <Select defaultValue="January" label="Month">
            <MenuItem value="January">January</MenuItem>
            <MenuItem value="February">February</MenuItem>
            <MenuItem value="March">March</MenuItem>
            <MenuItem value="April">April</MenuItem>
            <MenuItem value="May">May</MenuItem>
            <MenuItem value="June">June</MenuItem>
            <MenuItem value="July">July</MenuItem>
            <MenuItem value="August">August</MenuItem>
            <MenuItem value="September">September</MenuItem>
            <MenuItem value="October">October</MenuItem>
            <MenuItem value="November">November</MenuItem>
            <MenuItem value="December">December</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth required size="small" className="modal-form-row">
          <InputLabel>Year</InputLabel>
          <Select defaultValue="2025" label="Year">
            <MenuItem value="2019">2019</MenuItem>
            <MenuItem value="2020">2020</MenuItem>
            <MenuItem value="2021">2021</MenuItem>
            <MenuItem value="2022">2022</MenuItem>
            <MenuItem value="2023">2023</MenuItem>
            <MenuItem value="2024">2024</MenuItem>
            <MenuItem value="2025">2025</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </Modal>
  );
}
